import MessageDetails from './MessageDetails';
export default MessageDetails;
